import { RELATIONSHIP_TYPE_GUARANTOR_MAP } from '@/shared/constants/enumsMaps';
import { RelationTypeGuarantor } from '@/types';
import { OptionValue } from 'ui-kit';
import i18n from '@/i18n/i18n';
import { TKeys } from '@/i18n/useTranslate.ts';

export const relationTypeGuarantorSelectOptions: readonly {
  name: TKeys<'enums'>;
  value: RelationTypeGuarantor;
}[] = Object.values(RelationTypeGuarantor).map((type) => ({
  name: RELATIONSHIP_TYPE_GUARANTOR_MAP[type],
  value: type,
}));

export const ALL_STRING_OPTION: OptionValue = {
  value: 'all',
  label: i18n.t('ALL'),
};
